import { render } from "./ProfileFrame.vue?vue&type=template&id=764bcb01"
import script from "./ProfileFrame.vue?vue&type=script&lang=js"
export * from "./ProfileFrame.vue?vue&type=script&lang=js"

import "./ProfileFrame.vue?vue&type=style&index=0&id=764bcb01&lang=less"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__